import React from 'react';
import { connect } from 'react-redux';
import { Formik, Form } from 'formik';
import { withLocalize, Translate } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { relationsSearchActions, searchType, searchInstances, searchInstancesWithSaveEnabled } from '../../../store/relationsSearchStore';
import { layoutActions } from '../../../store/layoutStore';
import { isNullOrUndefined, validateInput } from '../../../store/storeFunctions';
import { withRouter } from 'react-router';
import { apiGet, getHostApi, isOnPath } from '../../../store/apiWrapper';
import { entityIdentRowActions } from '../../../store/entityIdentRowStore';
import SearchIcon from '../../../img/icons/Search';
import AngleDownIcon from '../../../img/icons/BBiconsRozbalit';
import * as Yup from '../../common/Yup';
import BbCollapse from '../../common/BbCollapse'
import classnames from 'classnames';
import moment from 'moment';

// Related components
import RelationsSearchQuickSearchResults from './relationsSearchQuickSearchResults';
import CalendarIcon from '../../../img/icons/Kalendar';

// Stylesheets
import "../../../css/search/search.scss";
import "../../../css/common/colors.css";
import { domainActions } from '../../../store/domainStore';
import { lastSubjectActions } from '../../../store/lastSubjectsStore';

class RelationsSearchSearch extends React.Component {
    searchInputRef = undefined;
    fakeSubmitId = '';

    constructor(props) {
        super(props);
        this.inputRef = React.createRef();
        this.fakeSubmitId = `fake-submit-${this.props.searchInstance.key}`;
    }

    opKetCodes = {
        9: function () { return false; }, /*TAB*/
        13: function () { return false; },
        16: function () { return false; }, /*SHIFT*/
        17: function () { return false; }, /*CTRL*/
        18: function () { return false; }, /*ALT*/
        27: function () { return false; }, /*ESC*/
        32: function () { return false; }, /*SPACE*/
        37: function () { return false; }, /*?*/
        38: function () { return false; }, /*?*/
        39: function () { return false; }, /*?*/
        40: function () { return true; }/*?*/
    }

    state = {
        query: undefined,
        stamp: 0,
        validLength: false,
        subjectsLoading: false,
        subjectsError: null,
        lastSearchedSubjects: [],
        qsResult: null,
        reset: false
    };

    componentDidUpdate(prevProps, prevState) {

        if (!searchInstancesWithSaveEnabled.includes(this.props.searchInstance.key) && !this.props[this.props.searchInstance.key].formExpanded) {
            this.props.toggleForm(this.props.searchInstance.key, true);
        }

        if (this.props[this.props.searchInstance.key].focusInput) {
            this.searchInputRef.focus();
            this.props.focusedQuickSearch(this.props.searchInstance.key);
        }
        if (isOnPath({ regex: /^\/search$/i }) && this.props.layout.topMenuExpanded) {
            this.props.expandTopMenu();
        }
        if (this.state.dob !== prevState.dob && this.props.isPo === prevProps.isPo) {
            this.onInputChanged(null, true);
        }
    }

    componentDidMount() {

        if (!isNullOrUndefined(this.props.marketAttribute)) {
            if (isNullOrUndefined(this.props.ls.lastSearchedSubjectsMarket[this.props.marketAttribute]) || this.props.ls.lastSearchedSubjectsMarket[this.props.marketAttribute].length === 0) {
                this.props.getSubjectsMarket(this.props.marketAttribute);
            }
        }

        !this.props.ls.isLoading && !this.props.ls.dataLoaded && !this.props.ls.error && this.props.getRelationsSubjects(this.props.searchInstance.key);
        const sp = this.props[this.props.searchInstance.key].searchParams || {};
        if (!isNullOrUndefined(this.props.history.location.state) && !isNullOrUndefined(this.props.history.location.state.reset))
            this.setState({ reset: this.props.history.location.state.reset, isSearching: false, qsResult: undefined });
        else {
            this.setState({ query: sp.name, isSearching: false, qsResult: undefined });
            this.searchInputRef.value = sp.name || '';
        }
        this.props.toggleForm(this.props.searchInstance.key, true);
    }


    render = () => {
        const isFormExpanded = this.props[this.props.searchInstance.key].formExpanded;
        // const isBasicFormExpanded = this.props[this.props.searchInstance.key].basicFormExpanded;
        const isPo = this.props[this.props.searchInstance.key].isPo;

        return (
            <>
                {!isNullOrUndefined(this.props.searchInstance.ordinal) && this.renderHeader()}

                <BbCollapse isOpen={isFormExpanded} className="w-100">
                    {(this.props.searchInstance.key === searchInstances.cee || this.props.searchInstance.key === searchInstances.cre || this.props.searchInstance.key === searchInstances.aml) ?
                        <div className="quick-search-container" style={{ padding: '0.5em 0.3em' }}>
                            <div className="search-box" style={{ display: 'block' }} >
                                {this.renderPoQuickSearchCee()}
                            </div>
                        </div>
                        :
                        <div className="quick-search-container" style={!isNullOrUndefined(this.props.searchInstance.ordinal) ? { padding: '1em 5% 1em 5%' } : { padding: '1em 10% 1em 10%', marginTop: '1em' }}>
                            {this.props.renderTypeTabs && <div className="switch">
                                <div className="btn-wrap">
                                    <div className="po-button" style={{ fontWeight: isPo ? "600" : "400" }}
                                        onClick={() => this.triggerChangeEntityType(true)}>{this.props.translate("Search.Common.Company")}</div>
                                    {isPo && <div className="search-progress-short" />}
                                </div>
                                <div className="btn-wrap">
                                    <div className="po-button" style={{ fontWeight: !isPo ? "600" : "400" }}
                                        onClick={() => this.triggerChangeEntityType(false)}>{this.props.translate("Search.Common.PhysicalPerson")}</div>
                                    {!isPo && <div className="search-progress-short" />}
                                </div>
                            </div>}
                            <div className="search-box" >
                                {isPo && this.renderPoQuickSearch()}
                                {!isPo && this.renderFoQuickSearch()}
                            </div>
                        </div>
                    }
                    {/*
                        !this.props[this.props.searchInstance.key].isPo &&
                        <div style={{ textAlign: 'center' }}>
                            <div className={`basic-search-link${isNullOrUndefined(this.state.qsResult) ? "" : " search-done"}`}
                                onClick={() => this.props.toggleBasicForm(this.props.searchInstance.key, !isBasicFormExpanded)} style={{ position: 'relative', top: '2px' }}>
                                <div className="basic-search-link-label">
                                    <Translate id={isBasicFormExpanded ? 'Search.BasicSearch.SectionName' : 'Search.Advanced.Search'} />&nbsp;
                                    <AngleDownIcon icon='angle-down' className='svg-standard-fill' style={{ transform: `scaleY(${isBasicFormExpanded ? -1 : 1})` }} />
                                </div>
                            </div>
                        </div>
                    */}
                    <div className="basic-search-form" style={{ width: '100%' }}>
                        <BbCollapse isOpen={false/*isBasicFormExpanded*/}>
                            <Formik enableReinitialize
                                onSubmit={(values) => this.submitNew(values)}
                                initialValues={this.createInitialValues()}
                                validationSchema={this.createValidationSchema()}
                                render={({ errors, status, touched }) => this.renderExtendedSearch(errors, touched)} />
                        </BbCollapse>
                    </div>
                    {(this.props.renderTypeTabs || this.props.showSearchButton) && <div className="columns m-0">
                        <div className="column" style={{ textAlign: "center", padding: "1em", marginBottom: "1em", display: "flex", flexBasis: "auto", flexWrap: "wrap", justifyContent: "center" }}>
                            <button onClick={() => document.querySelector(`#${this.fakeSubmitId}`).click()} style={{ fontWeight: 600 }} className={classnames('bb-button is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}><Translate id="Search.Common.Search" /></button>
                        </div>
                    </div>}
                </BbCollapse>

                {(!isFormExpanded || !isNullOrUndefined(this.props.searchInstance.query)) && this.renderSearchParamsLink(isFormExpanded)}
            </>
        );
    }

    triggerChangeEntityType = (val) => {
        this.setState({ isSearching: false, qsResult: undefined });
        this.props.triggerChangeEntityType(this.props.searchInstance.key, val);
    }

    renderHeader = () => {
        return (
            <div className="relationsSearch-card-header" >
                {!this.props.disableSubjectLabel && <span className="relationsSearch-card-header-content">{this.props.searchInstance.ordinal}. <Translate id="Search.Relations.Subject" /></span>}
            </div>
        );
    }

    renderFoQuickSearch = () => {
        return (
            <div className="search-inputs">
                <div className="control-row">
                    <div className="control rel-search-name">
                        <div style={{ display: "flex", alignItems: 'center', width: '100%' }}>
                            <span className='with-pointer'>
                                <SearchIcon fill='#969da1' className="search-icon-svg" viewBox='30 30 150 150' />
                            </span>
                            <input onFocus={() => this.onFocus()} ref={(el) => this.searchInputRef = el} autoComplete='off' style={{ paddingLeft: '.25em' }}
                                placeholder={this.props.translate("Search.Placeholder.Fo")} type="text" className='ellipsis search-input'
                                onKeyUp={this.onInputChanged} onKeyDown={this.onSearchSubmit} onInput={(e) => validateInput(e)}/>
                        </div>
                        <div className={classnames('search-progress', { 'searching': this.state.isSearching || (this.props.ls.isLoading && this.props[this.props.searchInstance.key].quickSearchResults.mainSearch) })} />
                        {this.renderQsResult({ extraData: 'desktop|mobile', basicLink: 'desktop', buttons: 'desktop' }, true, 2)}
                    </div>
                    <div className='control rel-search-dob' ref={(el) => this.searchDobRef = el}>
                        <div className={classnames("day-picker-ultimate", { 'babylon-success': this.state.validDob })} style={{ borderBottom: '1px solid #dbdbdb', display: 'flex' }}>
                        <CalendarIcon className='calendar' fill="currentColor" />
                            <input type="text" className='ellipsis search-input' onKeyUp={this.onDateChange}
                                onKeyDown={this.onSearchSubmit} autoComplete='off' ref={(el) => this.dobInputRef = el}
                                placeholder={this.props.translate("Search.Placeholder.Born")}
                                onInput={(e) => validateInput(e)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderPoQuickSearch = () => {
        return (
            <div className="search-inputs">
                <div className="control">
                    <div style={{ display: "flex", alignItems: 'center' }}>
                        <span className='with-pointer'>
                            <SearchIcon fill='#969da1' className="search-icon-svg" viewBox='30 30 150 150' />
                        </span>
                        <input onFocus={() => this.onFocus()} ref={(el) => this.searchInputRef = el} autoComplete='off'
                            placeholder={this.props.translate("Search.Placeholder")} type="text"
                            className={`ellipsis search-input${this.state.selectedResult !== null ? " real-entity-id" : ""}`}
                            onKeyUp={this.onInputChanged} onKeyDown={(e) => this.onSearchSubmit(e)}
                            onInput={(e) => validateInput(e)}
                        />
                    </div>
                    {this.renderQsResult({ extraData: 'desktop|mobile', basicLink: 'desktop', buttons: 'desktop' }, false, 1)}
                </div>
                <div className={classnames('search-progress', { 'searching': this.state.isSearching || (this.props.ls.isLoading && this.props[this.props.searchInstance.key].quickSearchResults.mainSearch) })} />
            </div>
        );
    }
    
    renderPoQuickSearchCee = () => {
        return (
            <div className="columns">
                <div className="column is-one-third">
                    <SearchIcon fill='#969da1' className="search-icon-svg" viewBox='30 30 150 150' style={{ display:'inline' }} />
                </div>
                <div className="column is-two-thirds">
                    <input onFocus={() => this.onFocus()} ref={(el) => this.searchInputRef = el} autoComplete='off'
                        placeholder={this.props.translate("Search.Placeholder")} type="text"
                        className={`input form-control ellipsis search-input${this.state.selectedResult !== null ? " real-entity-id" : ""}`}
                        onKeyUp={this.onInputChanged} onKeyDown={(e) => this.onSearchSubmit(e, !this.props.renderTypeTabs)}
                        onInput={(e) => validateInput(e)}
                        id='quickSearchInput'
                    />
                    {this.renderQsResult({ extraData: 'desktop|mobile', basicLink: 'desktop', buttons: 'desktop' }, false, 1)}
                </div>
                <div className={classnames('search-progress', { 'searching': this.state.isSearching || (this.props.ls.isLoading && this.props[this.props.searchInstance.key].quickSearchResults.mainSearch) })} />
            </div>
        );
    }

    renderQsResult = (mode, condensed, filterType) => {
        if (!this.props[this.props.searchInstance.key].quickSearchResults.mainSearch)
            return null;
        let lastSearchSubjects = this.lastSearchedSubjects();
        let isLoading = this.isLoading();

        return (<RelationsSearchQuickSearchResults subId='mainSearch'
            searchInputRef={[this.searchInputRef, this.searchDobRef]}
            sr={this.state.qsResult} mode={mode} condensed={condensed}
            ls={lastSearchSubjects}
            query={this.state.query} lsFilterType={filterType}
            subjectsLoading={isLoading}
            hideLastSubjectsOnMobile={true}
            searchInstance={this.props.searchInstance}
            onAction={this.props.onAction}
            isPo={this.props[this.props.searchInstance.key].isPo}
        />);
    }

    lastSearchedSubjects = () => {
        if (this.props.user.authentication.limitedUser)
            return [];
        if (isNullOrUndefined(this.props.marketAttribute))
            return this.props.ls.lastSearchedSubjects;
        else
            return this.props.ls.lastSearchedSubjectsMarket[this.props.marketAttribute];
    }

    isLoading = () => {
        if (this.props.user.authentication.limitedUser)
            return false;
        if (isNullOrUndefined(this.props.marketAttribute))
            return this.props.ls.isLoading;
        else
            return this.props.ls.isLoadingMarket[this.props.marketAttribute];
    }

    onDateChange = (event) => {
        const dob = (event.target.value || '').replace(/\s/g, '').replace(/[/\\]/g, '');
        const validDate = moment(dob, 'DD.MM.YYYY', true).isValid() || moment(dob, 'D.M.YYYY', true).isValid();
        const isId = !validDate && dob.length > 8 && dob.split('').filter(x => x >= '0' && x <= '9').length === dob.length;
        const isYear = !validDate && dob.length === 4 && dob.split('').filter(x => x >= '0' && x <= '9').length === dob.length;
        const lastValidDob = validDate || isId || isYear ? dob : this.state.lastValidDob;
        this.setState({ dob, validDob: validDate || isId, lastValidDob });
    }

    renderExtendedSearch = (errors, touched) => {
        return (
            <Form id={`search-form-${this.props.searchInstance.key}`}>
                <div style={{ display: "none" }}>
                    <input type="submit" id={this.fakeSubmitId}></input>
                </div>
            </Form>);
    }

    renderSearchParamsLink = (isFormExpanded) => {
        return (
            <div style={{ textAlign: 'center' }}>
                <div className={`basic-search-link`}
                    onClick={() => this.props.toggleForm(this.props.searchInstance.key, !isFormExpanded)}
                    style={{ position: 'relative', top: '2px' }}>
                    <div>
                        <span className="basic-search-link-label">
                            <Translate id="Search.Relations.SearchParameters" />&nbsp;
                                <AngleDownIcon
                                icon='angle-down'
                                className='svg-standard-fill'
                                style={{
                                    height: '1.5em', width: '1.5em',
                                    transform: `scaleY(${isFormExpanded ? -1 : 1})`, transition: 'all .5s ease'
                                }} />
                        </span>
                    </div>
                </div>
            </div>
        );
    }

    createValidationSchema = () => {
        const pinBdTest = /(^$)|(^\s*(\d\d)(\d\d)(\d\d)[\/]*(\d\d\d)(\d?)\s*$)|(^([0-9]|[0-2][0-9]|(3)[0-1])(\.|\/|-)([0-9]|((0)[0-9])|((1)[0-2]))(\.|\/|-)\d{4}$)/i;

        return (
            Yup.object().shape({
                'birthDate': Yup.string()
                    .matches(pinBdTest, { message: this.props.translate("Search.Common.Validation.WrongInput") })
            })
        )
    }

    createInitialValues = () => {
        const em = this.createEmptyValues();
        const sp = this.props[this.props.searchInstance.key].searchParams || {};
        if (this.state.reset) {
            return {
                name: em.name,
                bankAccount: em.bankAccount,
                dob: em.dob,
                street: em.street,
                rdc: em.rdc,
                isPo: this.props[this.props.searchInstance.key].isPo
            }
        } else {
            return {

                name: sp.name || em.name,
                bankAccount: sp.bankAccount || em.bankAccount,
                dob: sp.dob || em.dob,
                street: sp.street || em.street,
                rdc: this.parseRdc() || em.rdc,
                isPo: this.props[this.props.searchInstance.key].isPo
            };
        }
    }

    createEmptyValues = () => {
        return {
            name: '',
            bankAccount: '',
            dob: '',
            street: '',
            rdc: [],
            isPo: true
        };
    }

    submitNew = (values) => {
        const fd = this.getBasicSearchFormData(values);

        const domainLabels = this.getSelectedDomains(values);
        this.props.setRelationSearchDomain(this.props.searchInstance.key, domainLabels);
        this.props.toggleForm(this.props.searchInstance.key, false);
        //dont perform search yet, just push to qs, search results component will send the actual request
        this.props.onAction("submit", { entityId: undefined, query: this.createQueryString(fd) });
    }

    createQueryString = (fd) => {
        //search type and entity type always filled
        let qs = `type=${encodeURIComponent(searchType.BS)}`;
        qs += `&isPo=${encodeURIComponent(fd.isPo)}`;
        //optional params
        if (!isNullOrUndefined(this.state.query) && this.state.query !== "") qs += `&q=${encodeURIComponent(this.state.query)}`;
        if (!isNullOrUndefined(fd.bankAccount) && fd.bankAccount !== "") qs += `&bankAccount=${encodeURIComponent(fd.bankAccount)}`;
        if (!isNullOrUndefined(fd.dob) && fd.dob !== "") qs += `&dob=${encodeURIComponent(fd.dob)}`;
        if (!isNullOrUndefined(fd.rdcIds) && fd.rdcIds.length > 0) {
            qs += `&rdcIds=${fd.rdcIds.join(",")}`;
        }
        if (!isNullOrUndefined(fd.street) && fd.street !== "") qs += `&street=${encodeURIComponent(fd.street)}`;

        return qs;
    }

    getSelectedDomains = (values) => {
        let rdc = {};
        values.rdc.forEach(x => rdc[x.value] = x.label);
        return {
            'rdcIds': rdc
        }
    }

    getBasicSearchFormData = (values) => {
        return {
            "name": this.getString(values.name),
            "dob": this.state.dob,
            "street": this.getString(values.street),
            "rdcIds": values.rdc.filter(x => x.value !== "").map(x => x.value),
            "isPo": this.props[this.props.searchInstance.key].isPo,
            "bankAccount": values.bankAccount
        }
    }

    getString = (s) => isNullOrUndefined(s) || s.trim() === "" ? null : s.trim().replace(/\s+/gi, " ");

    onInputChanged = (event, force = false) => {
        if (!force) {
            if (isNullOrUndefined(event) || isNullOrUndefined(event.target) || isNullOrUndefined(event.target.value)) {
                this.props.hideQuickSearchResults(this.props.searchInstance.key, 'mainSearch');               
                this.setState({ query: '' });
                return;
            }

            const keyCode = event.keyCode.toString();
            if (Object.keys(this.opKetCodes).indexOf(keyCode) !== -1) {
                if (!this.opKetCodes[keyCode]())
                    if (keyCode !== "32")
                        return;
                    else if ((event.target || {}).selectionEnd === ((event.target || {}).value || {}).length)   //skip space only in the end
                        return;
            }
        }

        const term = force ? this.state.query : (((event || {}).target || {}).value || { trim: function () { return undefined } }).trim();
        if ((this.state.lastValidDob == null || this.state.lastValidDob.length === 4) && (term !== null && term !== undefined && term.length <= 2)) {
            this.props.hideQuickSearchResults(this.props.searchInstance.key, 'mainSearch');           
            this.setState({ qsResult: null, query: term });
        }
        else if ((this.state.lastValidDob != null && this.state.lastValidDob.length !== 4 && (term === undefined || term === '')) || (term !== null && term !== undefined && term.length >= 3)) {
            let runSearch = false;
            let dobToRun = '';
            if (term === this.state.query) {
                if (this.state.lastValidDob !== null && this.state.lastValidDob !== undefined && this.state.lastValidDob === this.state.dob) {
                    runSearch = true;
                    dobToRun = this.state.lastValidDob;
                }
            } else if (this.state.lastValidDob !== this.state.dob) {
                this.dobInputRef.value = '';
                runSearch = true;
            } else {
                runSearch = true;
                dobToRun = this.state.lastValidDob;
            }

            if (runSearch) {
                const newStamp = this.state.stamp + 1;
                this.props.showQuickSearchResults(this.props.searchInstance.key, 'mainSearch');                
                this.setState({ validLength: true, query: term, stamp: newStamp });
                this.loadQs(term, dobToRun, newStamp);
            }
        } else {
            this.setState({ validLength: false, query: term });
        }
    }

    onSearchSubmit = (event, disableEnter = false) => {
        if (disableEnter && event.key === 'Enter') return;
        if (event.key !== 'Enter' || isNullOrUndefined(event) || isNullOrUndefined(event.target) || isNullOrUndefined(event.target.value)) {
            return;
        }
        ((!isNullOrUndefined(this.state.query) && this.state.query.length > 2) || (!isNullOrUndefined(this.state.lastValidDob) && this.state.validDob)) && document.querySelector(`#${this.fakeSubmitId}`).click();
    }

    loadQs = (query, dob, stamp) => {
        this.setState({ isSearching: true });
        if (this.state.pendingReq !== undefined) {
            clearTimeout(this.state.pendingReq);
        }
        this.setState({
            pendingReq: setTimeout(function () {
                var market = null;
                var secondMarket = null;
                if (!isNullOrUndefined(this.props.marketAttribute)) {
                    if (this.props.marketAttribute === 3) {
                        market = 1;
                        secondMarket = 2;
                    }
                    else
                        market = this.props.marketAttribute;
                }
                apiGet.call(this, `${getHostApi()}/api/search/quick`, { query, stamp, type: this.props[this.props.searchInstance.key].isPo ? 1 : 2, dob: dob, market, secondMarket },
                    res => {
                        if (res.data.stamp === this.state.stamp && (this.props[this.props.searchInstance.key].isPo ? 1 : 2) === res.data.searchType) {
                            this.setState({ qsResult: res.data });
                            this.props.syncFromSearch(res.data.subjects);
                        }
                    },
                    err => { },
                    alw => this.setState({ isSearching: false }))
            }.bind(this), 125)
        });
    }

    domainsLoading = () => {
        return this.props.domain['region-district-city'].isRequesting || this.props.domain['region-district-city'].requestResult == null;
    }

    parseRdc = () => {
        //wait for rdc to load then parse from query string and put to store
        if (!this.domainsLoading() && this.props[this.props.searchInstance.key].searchDomains !== null) {
            let rdc = [];
            Object.keys(this.props[this.props.searchInstance.key].searchDomains.rdcIds).map(s => {
                let found = this.props.domain['region-district-city'].requestResult.find(x => x.value === s);
                rdc.push(found);
            })
            return rdc;
        }
        return [];

    }

    onFocus = () => {
        !this.props[this.props.searchInstance.key].quickSearchResults.mainSearch && this.props.showQuickSearchResults(this.props.searchInstance.key, 'mainSearch');        
    }
}

export default withRouter(withLocalize(connect(
    state => { return { ...state.relationsSearch, layout: state.layout, domain: state.domain, ls: state.lastSubjects, user: state.userContext } },
    dispatch => bindActionCreators(Object.assign({}, relationsSearchActions, layoutActions, entityIdentRowActions, domainActions, lastSubjectActions), dispatch),
)(RelationsSearchSearch)));